"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGetFullKeyEndpoint = createGetFullKeyEndpoint;
const createGetFullKeyEndpointFromExisting_1 = require("./createGetFullKeyEndpointFromExisting.js");
const sonar_http_1 = require("@sonar-software/sonar-http");
function createGetFullKeyEndpoint(uri, options) {
    const base = (0, sonar_http_1.createGetEndpoint)(uri, options);
    return (0, createGetFullKeyEndpointFromExisting_1.createGetFullKeyEndpointFromExisting)(base, options === null || options === void 0 ? void 0 : options.count);
}
//# sourceMappingURL=createGetFullKeyEndpoint.js.map